/**
 * @see https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_isfunction
 */
export default (function (value) {
    return typeof value === 'function';
});
//# sourceMappingURL=is-function.js.map